export default __webpack_public_path__ + "static/media/14204-403255-19106.19fb3b46.jpg";